import { ComponentProps } from 'react';
import ReactStickyBox, { StickyBoxCompProps } from 'react-sticky-box';
import { Layout } from '@/shared/ui/layout';

export const StickyBox = (props: ComponentProps<typeof Layout> & StickyBoxCompProps) => {
    return <Layout element={ReactStickyBox} {...props} />;
};
